var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 107,
    viewBox: "0 0 90 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.875 12.9138C68.625 4.79655 57.375 0 45 0C32.625 0 21.375 4.79655 13.125 12.9138C4.875 21.031 0 32.1 0 44.2759C0 56.4517 4.875 67.5207 13.125 75.6379L45 107L76.875 75.6379C85.125 67.5207 90 56.4517 90 44.2759C90 32.1 85.125 21.031 76.875 12.9138ZM45 55.3448C38.625 55.3448 33.75 50.5483 33.75 44.2759C33.75 38.0034 38.625 33.2069 45 33.2069C51.375 33.2069 56.25 38.0034 56.25 44.2759C56.25 50.5483 51.375 55.3448 45 55.3448Z",
    fill: "#7363F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.60358d12c239d8f8473c430cf81c337d.svg";
export { ForwardRef as ReactComponent };